var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0677 31.4324C37.6445 29.0102 34.3585 27.6495 30.9323 27.6495C27.5061 27.6495 24.2202 29.0102 21.797 31.4324L12.6587 40.5677C10.2355 42.991 8.87411 46.2776 8.87411 49.7045C8.87411 53.1315 10.2355 56.4181 12.6587 58.8414C15.0819 61.2646 18.3685 62.626 21.7955 62.626C25.2225 62.626 28.5091 61.2646 30.9323 58.8414L35.5 54.2737",
    stroke: "#1B1B1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9323 40.5677C33.3555 42.9899 36.6415 44.3506 40.0677 44.3506C43.4939 44.3506 46.7798 42.9899 49.203 40.5677L58.3413 31.4324C60.7645 29.0091 62.1259 25.7225 62.1259 22.2955C62.1259 18.8686 60.7645 15.582 58.3413 13.1587C55.9181 10.7355 52.6314 9.37415 49.2045 9.37415C45.7775 9.37415 42.4909 10.7355 40.0677 13.1587L35.5 17.7264",
    stroke: "#1B1B1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.16aaae1c5c7a8c8cf4e23300d3f0bfd8.svg";
export { ForwardRef as ReactComponent };